import React from "react"

import { Section, SectionTitle, Text } from "@jewlr/storybook/info"
import { Box } from "components/common/index"
import { jewlr_t } from "helpers/application"

const DisruptiveRing = () => (
  <Box mb={7}>
    <Section>
      <Box contain>
        <SectionTitle>
          Online Jeweller Business Has A Disruptive Ring
        </SectionTitle>

        <Text>
          Tony Davis confesses he didn&apos;t know a thing about{" "}
          {jewlr_t("terms.jewelry")} when he decided to launch on an online
          website to sell {jewlr_t("terms.personalized")} designs.
        </Text>
        <Text>
          The Thornhill software engineer-turned-venture capitalist figured
          there had to a way to modernize the {jewlr_t("terms.jewelry")}{" "}
          business. He was convinced shoppers would happily use the Internet to
          buy everything from rings to charms, complete with engraved messages.
        </Text>
        <Text>
          Read full article{" "}
          <a
            href="https://www.thestar.com/business/2013/12/09/online_jeweller_business_has_a_disruptive_ring.html"
            rel="noopener noreferrer"
            target="_blank"
          >
            here
          </a>
        </Text>
      </Box>
    </Section>
  </Box>
)
export default DisruptiveRing
